import React, {FC} from 'react';

import {Trans} from '../../../libs/shared/helpers/src/internationalization/react';
import {useAppSelector} from '../../helpers/reduxHelpers';
import {getHasCommentComposerListServiceV2} from '../../store/featureFlags/featureFlagsSelectors';
import {ViewerPanelId} from '../../store/panels/panelStateBase';
import {FrameTitle} from '../common/frames/frameTitle';
import {InternalComposerContainer} from '../inboxes/viewer/internalComposer/internalComposerContainer';

/*
 * Props.
 */

interface PopupViewerComposerProps {
  panelId: ViewerPanelId;
  commentUid: string;
  hasQuoteComment: boolean;
}

/*
 * Component.
 */

export const PopupViewerComposer: FC<PopupViewerComposerProps> = (props) => {
  const hasListServiceV2 = useAppSelector(getHasCommentComposerListServiceV2);
  return (
    <>
      <FrameTitle>
        <Trans id="composer-internal-popup-title">New Discussion</Trans>
      </FrameTitle>
      <InternalComposerContainer
        conversation={null}
        {...props}
        hasAutoShareDrafts={false}
        hasListServiceV2={hasListServiceV2}
      />
    </>
  );
};
